import { useMemo } from "react";
import { validateCondition } from "@storyai/shared";

export const CONDITION_HINT =
  "has:key · flag:key · visited:chapter_key · AND / OR / NOT · parentheses. Empty = always true.";

/** Text input for a condition expression with live parse validation. */
export function ConditionInput({
  value,
  onChange,
  placeholder = "e.g. has:brass_key AND NOT flag:injured",
  disabled,
  showHint = true,
  id,
}: {
  value: string;
  onChange: (next: string) => void;
  placeholder?: string;
  disabled?: boolean;
  showHint?: boolean;
  id?: string;
}) {
  const error = useMemo(() => validateCondition(value), [value]);
  return (
    <span className="condition-input">
      <input
        id={id}
        type="text"
        className={`mono ${error ? "input-invalid" : ""}`}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        spellCheck={false}
        onChange={(e) => onChange(e.target.value)}
        aria-invalid={!!error}
      />
      {error ? (
        <span className="field-error">{error}</span>
      ) : (
        showHint && <span className="muted small field-hint">{CONDITION_HINT}</span>
      )}
    </span>
  );
}

export function conditionIsValid(value: string): boolean {
  return validateCondition(value) === null;
}
